// removed by extract-text-webpack-plugin
module.exports = {"title":"_1xe3V"};


//////////////////
// WEBPACK FOOTER
// ./app/components/EInvoiceSelector/EInvoiceSelector.scss
// module id = 1513
// module chunks = 1